/**
 * Videocall Save Messages Service
 *
 * Handles saving videocall conversation messages to the WordPress chat database
 * and displaying them in real-time within the chat UI.
 *
 * Called from videocall.js event handlers (response_complete / response_completed).
 */
const $ = jQuery;

/**
 * Check if the "Save to Chat" toggle is enabled in the videocall modal.
 */
export function saveMessagesEnabled() {
    return $('input[name="growtype_chat_video_chat_save_messages"]').is(':checked');
}

/**
 * Check if the "Auto Listen" toggle is enabled in the videocall modal.
 */
export function autoRecordEnabled() {
    return $('input[name="growtype_chat_video_chat_auto_record"]').is(':checked');
}

/**
 * Complete a LiveKit assistant turn.
 *
 * The generated opening remains audio-only. Every later final answer enters
 * the same combined persistence and chat-rendering path used by other voice
 * transports.
 */
export function completeLiveKitAssistantTurn(ctx) {
    if (!ctx.final) return false;

    ctx.onFinal();
    if (ctx.openingResponsePending) {
        ctx.clearOpeningTranscripts();
        return false;
    }

    ctx.saveMessages();
    return true;
}

/**
 * Save the current videocall turn (user transcript + AI response) to the
 * WordPress database and display both messages in the chat UI.
 *
 * Safe to call multiple times — a double-save guard prevents duplicate saves
 * within the same AJAX lifecycle.
 *
 * @param {jQuery} chatForm      The .g-chatform element
 * @param {string} sessionToken   The session token
 * @param {function} debugLog     Logging function (pass from videocall closure)
 */
export function saveVideocallMessages(chatForm, sessionToken, debugLog) {
    if (!saveMessagesEnabled() || !window.__aiResponseTranscript) return;
    if (window.__saveInProgress) return;
    window.__saveInProgress = true;

    const userMsg = window.__userTranscript || "";
    const aiMsg = window.__aiResponseTranscript;

    debugLog("💾 Auto-saving videocall messages to chat history...");

    $.ajax({
        url: growtype_chat_ajax.url,
        type: "post",
        data: {
            action: "growtype_chat_videocall_save_messages",
            session_token: sessionToken,
            nonce: growtype_chat_ajax.nonce,
            user_message: userMsg,
            assistant_message: aiMsg,
        },
        success: function (resp) {
            if (resp.success) {
                debugLog("✅ Messages saved to database");
            }
        },
        error: function (resp) {
            console.error("❌ Failed to save videocall messages:", resp);
        },
        complete: function () {
            window.__saveInProgress = false;
        }
    });

    // Show in chat UI in real-time
    if (chatForm && chatForm.length) {
        var cw = chatForm.find(".g-chatform-content");
        if (cw.length) {
            if (userMsg) {
                var ut = chatForm.find('[data-role="admin"]').first().clone();
                ut.removeClass("is-pending-response g-chatform-message-generating");
                ut.find(".g-chatform-message-content-inner").text(userMsg);
                ut.find(".g-chatform-message-inner").show();
                ut.show();
                cw.append(ut);
            }
            var at = chatForm.find('[data-role="user"]').first().clone().show();
            at.find(".g-chatform-message-content-inner").text(aiMsg);
            cw.append(at);
            cw.scrollTop(cw[0].scrollHeight);
        }
    }

    window.__userTranscript = "";
    window.__aiResponseTranscript = "";
}
